<template>

  <v-row align="center" justify="center" height="100vh" min-height="100vh" fill-height>
    <v-col align="center" justify="center">
      <InstantMeetingButton />
    </v-col>
  </v-row>

</template>

<script>

import InstantMeetingButton from "@/components/InstantMeetingButton.vue";
export default {
  name: 'InstantMeetingView',
  components: {
      InstantMeetingButton
  },
  data: () => ({

  }),

}

</script>